/**
 * Utility functions for book data formatting
 */

/**
 * Extract short title (everything before the colon)
 * e.g. "Atomic Habits: An Easy & Proven Way..." → "Atomic Habits"
 */
export function getShortTitle(fullTitle: string): string {
  const colonIndex = fullTitle.indexOf(':');
  if (colonIndex === -1) return fullTitle;
  return fullTitle.substring(0, colonIndex).trim();
}

/**
 * Get short book description (first 1-2 sentences)
 * @param introduction - Book introduction text
 * @param maxLength - Maximum character length (default: 120)
 */
export function getShortDescription(introduction?: string, maxLength: number = 120): string {
  if (!introduction) return '';
  
  // Remove HTML tags first
  let cleanText = introduction.replace(/<[^>]*>/g, '');
  
  // Clean up markdown symbols
  cleanText = cleanText
    .replace(/[#*_`]/g, '') // Remove markdown symbols
    .replace(/\s+/g, ' ') // Normalize whitespace
    .trim();
  
  // If short enough, return as-is
  if (cleanText.length <= maxLength) return cleanText;
  
  // Try to break at sentence boundary
  const sentences = cleanText.match(/[^.!?]+[.!?]+/g) || [];
  if (sentences.length > 0) {
    const firstSentence = sentences[0].trim();
    if (firstSentence.length <= maxLength) return firstSentence;
  }
  
  // Fallback: truncate at word boundary
  const truncated = cleanText.substring(0, maxLength);
  const lastSpace = truncated.lastIndexOf(' ');
  if (lastSpace > maxLength * 0.8) {
    return truncated.substring(0, lastSpace) + '...';
  }
  
  return truncated + '...';
}

/**
 * Format insights count display
 */
export function formatInsightsCount(count?: number): string | undefined {
  if (count === undefined || count === 0) return undefined;
  return `${count} Insight${count !== 1 ? 's' : ''}`;
}

